module.exports = __webpack_public_path__ + "static/media/01_digginglight.7d85467b.jpg";